import storeInfo from "../store";
import { MatchItem } from "../types";

export const getMatch = () => (): MatchItem => {
    const { match } = storeInfo.store.getState()

    return match
}